import React from "react";
import ModalContainer from "Components/Common/Modal/ModalContainer";
import ModalBody from "Components/Common/Modal/ModalBody";
import FillButton from "Components/Common/components/Button/FillButton";
import BorderedButton from "Components/Common/components/Button/BorderedButton";
import { CANCEL, YES } from "../ARSConstants";
import ModalFooter from "Components/Common/Modal/ModalFooter";

type ConfirmModalProps = {
    showModal: boolean;
    closeModal: () => void;
    onConfirm: () => void;
    primaryMessage?: string;
    primarySubMessage?: string;
    secondaryMessage?: string;
    secondarySubMessage?: string;
    id?: string;
}

const ConfirmModal = ({ showModal, closeModal, onConfirm, primaryMessage = '', primarySubMessage = '', secondaryMessage = '', secondarySubMessage = '', id }: ConfirmModalProps) => {
    return (
        <ModalContainer
            id={id}
            isOpen={showModal}
            setOpen={closeModal}>
            <ModalBody>
            <div className="tw-space-y-3 tw-mt-5">
                    {primarySubMessage && primaryMessage ? <center><p>{primaryMessage}</p></center> : null}
                <div className="tw-bg-red-50 tw-space-x-3 tw-p-2 tw-px-3 tw-rounded ">
                    {!primarySubMessage && primaryMessage ? <center><p>{primaryMessage}</p></center> : null}
                    {primarySubMessage ? <center><p>{primarySubMessage}</p></center> : null}
                    {secondaryMessage ? <center><p>{secondaryMessage}</p></center> : null}
                </div>
                <div>
                    {secondarySubMessage ? <center><p>{secondarySubMessage}</p></center> : null}
                </div>
            </div>
            </ModalBody>
            <ModalFooter>
                <div className="tw-flex tw-max-w-full tw-w-full tw-justify-center tw-items-center tw-space-x-3">
                    <BorderedButton id={id ? `${id}-cancel-btn` : undefined} onClick={() => closeModal()}>{CANCEL}</BorderedButton>
                    <FillButton id={id ? `${id}-confirm-btn` : undefined} className={`!tw-border-red-500 !tw-cursor-pointer !tw-bg-red-500 hover:!tw-bg-primary-hover hover:!tw-border-primary-hover`} onClick={onConfirm} disabledClassName = "!tw-border-red-error-200 !tw-bg-red-error-200">{YES}</FillButton>
                </div>
            </ModalFooter>
        </ModalContainer>

    )
}

export default ConfirmModal;